import { AfterViewInit, Component, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { finalize, firstValueFrom, switchMap } from 'rxjs';
import { SpinnerOverlayComponent } from 'src/app/components/spinner-overlay/spinner-overlay.component';
import { RuoliList, UtenteService } from 'src/app/services/utente/utente.service';
import { UtilityService } from 'src/app/services/utility/utility.service';
import { GestioneLicenzeComponent } from '../../gestione-licenze/gestione-licenze.component';
import { LicenzeService } from './../../../../services/licenze/licenze.service';

@Component({
  selector: 'app-dialog-gestione-licenze',
  templateUrl: './dialog-gestione-licenze.component.html',
  styleUrls: ['./dialog-gestione-licenze.component.scss'],
  standalone: false,
})
export class DialogGestioneLicenzeComponent implements AfterViewInit {
  @ViewChild(SpinnerOverlayComponent) spinnerOver!: SpinnerOverlayComponent;
  @ViewChild(GestioneLicenzeComponent) gestioneLicenzeComponent!: GestioneLicenzeComponent;

  constructor(
    public dialogRef: MatDialogRef<DialogGestioneLicenzeComponent>,
    private readonly licenzeService: LicenzeService,
    private readonly utilityService: UtilityService,
    private readonly utenteService: UtenteService,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      tipo: string;
      idUtente: string;
      ruoloUtente: RuoliList;
      codiceLicenza: string;
      record: any;
      dataScadenzaMax: string;
      codicePromotore: string | undefined;
      isUtenteGO: boolean;
      idSettoriPacchettoAttivo: string[];
    },
  ) {}

  ngAfterViewInit(): void {
    const formLicenze = this.gestioneLicenzeComponent?.formLicenze;
    if (this.data.record) {
      // Sono in modifica
      formLicenze.disable();
      formLicenze.get('dataScadenza')?.enable();
      formLicenze.get('integrazioneIA')?.enable();
      formLicenze.get('rinnovoAutomatico')?.enable();
    } else {
      // Sono in creazione nuova

      let dataAttivazione = new Date();

      if (this.data.tipo === 'rinnovo') {
        let data = new Date(this.data.dataScadenzaMax); // Data scadenza dell'ultimo RINNOVO
        data.setDate(data.getDate() + 1); // Aggiungo un giorno dalla scadenza del pacchetto più

        dataAttivazione = data;
        formLicenze.get('storage')?.setValue(5);
        formLicenze.get('idSettori')?.setValue(this.data.idSettoriPacchettoAttivo || []);
      }
      if (this.data.tipo === 'estensione') {
        formLicenze.get('idSettori')?.setValue([]);
        formLicenze.get('storage')?.setValue(0);
      }

      if (this.data.tipo === 'aggiuntivo') {
        formLicenze.get('storage')?.setValue(0);
      }

      formLicenze.get('dataAttivazione')?.setValue(dataAttivazione);

      this.gestioneLicenzeComponent.minDate = dataAttivazione;

      formLicenze
        .get('dataScadenza')
        ?.setValue(this.gestioneLicenzeComponent.calcolaDataScadenza(dataAttivazione));

      if (this.data.tipo === 'estensione') {
      }
    }
  }

  /**
   * Metodo che salva un pacchetto Aggiuntivo o un Rinnovo
   */
  public async salva() {
    const idUtente = this.data?.idUtente;
    const codiceLicenza = this.data?.codiceLicenza;
    const codicePacchetto = this.gestioneLicenzeComponent.formLicenze.get('codicePacchetto')?.value;
    const objLicenza = this.gestioneLicenzeComponent.getObjLicenze(idUtente);

    if (idUtente && codiceLicenza) {
      if (!codicePacchetto) {
        // Controllo che ci sia almeno un valore inserito
        const totLic =
          (this.gestioneLicenzeComponent.formLicenze.get('nrAutovalutazioni')?.value ?? 0) +
          (this.gestioneLicenzeComponent.formLicenze.get('nrBilanci')?.value ?? 0) +
          (this.gestioneLicenzeComponent.formLicenze.get('nrSintesi')?.value ?? 0) +
          (this.gestioneLicenzeComponent.formLicenze.get('nrVSME')?.value ?? 0) +
          (this.gestioneLicenzeComponent.formLicenze.get('nrMaterialita')?.value ?? 0) +
          (this.gestioneLicenzeComponent.formLicenze.get('nrPolicy')?.value ?? 0) +
          (this.gestioneLicenzeComponent.formLicenze.get('nrPiano')?.value ?? 0) +
          (this.gestioneLicenzeComponent.formLicenze.get('nrMultimodulo')?.value ?? 0) +
          (this.gestioneLicenzeComponent.formLicenze.get('storage')?.value ?? 0) +
          (this.gestioneLicenzeComponent.formLicenze.get('idSettori')?.value.length ?? 0) +
          (this.gestioneLicenzeComponent.formLicenze.get('nrMaxAziende')?.value ?? 0);

        if (totLic === 0) {
          // Nessun valore inserito
          await this.utilityService.openDialog({
            titolo: 'Attenzione',
            descrizione: 'Inserire almeno un valore di licenza maggiore di zero per salvare.',
            bottoni: [
              {
                nome_btn: 'Ok',
              },
            ],
          });
          return;
        }
      }

      // Aggiornno Pacchetto (aggiuntivo o rinnovo)
      if (this.data.record && codicePacchetto) {
        await this.gestioneLicenzeComponent.aggiornaLicenzaBase(
          idUtente,
          codiceLicenza,
          codicePacchetto,
        );
        try {
          // 2. Attende che le info utente siano aggiornate effettivamente
          await firstValueFrom(this.utenteService.aggiornaInfoUtente());
        } catch (err) {
          console.error("Errore durante l'aggiornamento info utente", err);
        }
        this.dialogRef.close();
      } else {
        // Creo nuovo Pacchetto (aggiuntivo o rinnovo)
        let endpoint: any;

        switch (this.data.tipo) {
          case 'rinnovo':
            endpoint = this.licenzeService.rinnovoLicenzaBase(codiceLicenza, idUtente, objLicenza);
            break;

          case 'aggiuntivo':
            endpoint = this.licenzeService.aggiungiPacchettoAggiuntivo(
              codiceLicenza,
              idUtente,
              objLicenza,
            );
            break;

          case 'estensione':
            endpoint = this.licenzeService.aggiungiEstensioneLicenzaBase(
              codiceLicenza,
              idUtente,
              objLicenza,
            );
            break;

          default:
            endpoint = undefined;
            break;
        }

        if (endpoint) {
          this.spinnerOver.show();

          endpoint
            .pipe(
              // Concatena l'aggiornamento utente dopo il successo dell'endpoint
              switchMap((esito) => this.utenteService.aggiornaInfoUtente()),
              finalize(() => this.spinnerOver.hide()),
            )
            .subscribe({
              next: () => {
                this.dialogRef.close();
              },
              error: (err: any) => {
                console.error(err);
                this.utilityService.openDialog({
                  titolo: 'Attenzione',
                  descrizione: err?.error?.message || "Errore durante l'operazione",
                  bottoni: [{ nome_btn: 'Ok' }],
                });
              },
            });
        } else {
          console.error('TIPO AZIOINE NON DEFINITO');
        }
      }
    }
  }
  /**
   * Metodo che mi configura il titolo
   * @returns
   */
  returnTitolo() {
    switch (this.data.tipo) {
      case 'rinnovo':
        return 'Rinnovo Licenza';

      case 'estensione':
        return 'Estensione Licenza base';

      case 'aggiuntivo':
        return 'Pacchetto Aggiuntivo';

      default:
        return 'Gestione Licenze';
    }
  }
}
